export const cardReplacement = {
    enabled: false,
    _description:
        'Displays card replacement focus page with fees - AT only - Orders a replacement card for a card that has been successfully locked',
};
